import React, { useState, useEffect, useRef } from "react";
import ProfileImg from "../../../assets/website/img/profile-img.jpg";
import { useTranslation } from "react-i18next";

function AboutSection() {
  const { t, i18n } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing after it's visible
        }
      },
      { threshold: 0.4 } // Trigger when 30% of the section is visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" className="about section" ref={sectionRef}>
      {isVisible && (
        <div className="container">
          <div className="row gy-4 justify-content-center">
            <div className="col-lg-4">
              <img src={ProfileImg} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-8 content">
              <h2 className="text-white" style={{ fontFamily: "Tajawal" }}>
                {t("aboutTitle")}
              </h2>

              <div className="row">
                <div className="col-lg-6">
                  <ul>
                    <li>
                      <i className="bi bi-chevron-right" />
                      <strong>{t("phone")}:&nbsp;</strong>
                      <span
                        style={{
                          direction: i18n.language === "ar" ? "ltr" : "ltr",
                        }}
                      >
                        +90 538 958 70 88
                      </span>
                    </li>
                    <li>
                      <i className="bi bi-chevron-right" />
                      <strong>{t("city")}:&nbsp;</strong>
                      <span>{t("city2")}</span>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6">
                  <ul>
                    <li>
                      <i className="bi bi-chevron-right" />
                      <strong>{t("email")}:&nbsp;</strong>
                      <span>mohammad98.sn@gmail.com</span>
                    </li>
                    <li>
                      <i className="bi bi-chevron-right" />
                      <strong>{t("freelance")}:&nbsp;</strong>
                      <span>{t("available")}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default AboutSection;
